import angular from 'angular';
import { ssDialogService, loaderService, eduDataService } from 'app/services';
import copy from 'app/constants';
import trainingAdminMedia from './media';

import trainingAdministrationDirective from './training-administration.directive';
import TrainingAdministrationDirectiveController from './training-administration.directive.controller';

export const routeConfig = {
  template: require('./training-administration.directive.html'),
  controller: 'TrainingAdministrationDirectiveController',
  controllerAs: 'trainingAdminVM',
};

export default angular.module('app.components.admin.trainingAdministration', [
  copy,

  ssDialogService,
  loaderService,
  eduDataService,

  trainingAdminMedia
])
  .directive('trainingAdministrationDirective', trainingAdministrationDirective)
  .controller('TrainingAdministrationDirectiveController', TrainingAdministrationDirectiveController)
  .name;

console.log('app.components.admin.trainingAdministration created');
